<template>
  <div>
    <div class="footer" :class="{ 'footer-gap': gap }">
      <div class="footer-inner" @click="click">
        <div class="prepend">
          <iain-image-domain w="80" h="80" src="static/img/logo_2.jpeg" />
          <div class="content">
            <div>下载聚亲APP</div>
            <div>获得更多精彩信息</div>
          </div>
        </div>

        <div class="append">
          <span>立即下载</span>
        </div>
      </div>

    </div>
    <div class="weixin-tip" v-if="isWx">
      <p>
        <img style="width: 93vw" src="static/img/live_weixin.png" alt="微信打开" />
        <span id="close" title="关闭" class="close" @click="close">×</span>
      </p>
    </div>
  </div>

</template>

<script>
export default {
  name: 'download',
  props: {
    gap: {
      type: Boolean,
      default: false
    },
    scheme: {
      type: String,
      default: ''
    },
    immediately: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isWx: false
    }
  },
  mounted () {
    // this.immediately && this.click()
  },
  methods: {
    close () {
      this.isWx = false
    },
    click () {
      const ua = navigator.userAgent.toLocaleLowerCase()
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.isWx = true
        return;
      } else {
        this.isWx = false
      }
      let schemeUrl = this.scheme
      const storeUrl = this.$store.state.$isIos
        ? 'https://apps.apple.com/cn/app/%E8%81%9A%E4%BA%B2/id1535740004'
        : 'https://file.kinfriend.com/package/juqin157.apk'

      // 每次携带上最新时间戳
      if (schemeUrl) {
        schemeUrl += `&schemeTime=${new Date().getTime()}`
      }

      window.AROUSE.OPEN({ schemeUrl, storeUrl })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  height: 100px;

  &.footer-gap {
    height: 0;
  }

  .footer-inner {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    height: 100px;
    padding-left: 30px;
    background-color: rgba(0, 0, 0, 0.65);

    .prepend {
      display: flex;
      align-items: center;
      font-size: 30px;
      color: #002121;

      .content {
        color: #ffffff;
        font-size: 24px;
        margin-left: 15px;
      }
    }

    .append {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ff5500;
      width: 265px;
      height: 100px;
      font-size: 34px;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
.weixin-tip {
  display: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  filter: alpha(opacity=80);
  width: 100%;
  height: 100%;
  z-index: 100;
}

.weixin-tip p {
  text-align: center;
  margin-top: 10%;
  padding: 0 5%;
  position: relative;
}
</style>
